import React, { Component } from 'react'
import { ApolloProvider } from 'react-apollo'
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks'

import { Provider as ReduxProvider } from 'react-redux'
import graphqlClient from 'lib/graphql'
import configureStore from '../store'
import { UserContextProvider } from '../context/UserContext'
import ErrorBoundary from 'components/ErrorBoundary'
import ErrorPage from 'components/ErrorPage'
import Routes from '../routes'
import { setTypewriterOptions } from 'analytics/typewriter'
import { toaster } from 'evergreen-ui'

const store = configureStore()

// Root handles initializing the app.
class Root extends Component {
  componentDidMount() {
    setTypewriterOptions({
      // Note that this handler only fires in development mode.
      onViolation: (msg, violations) => {
        // console.warn() messages have been easy to miss. This makes it obvious
        // whenever an analytics call you're making does not match our spec.
        toaster.warning(`"${msg.event}" Fired with Tracking Plan Violation`, {
          description: violations[0].message
        })
      }
    })
  }

  render() {
    return (
      <ErrorBoundary errorComponent={ErrorPage}>
        <ReduxProvider store={store}>
          <ApolloProvider client={graphqlClient}>
            <ApolloHooksProvider client={graphqlClient}>
              <UserContextProvider>
                <Routes />
              </UserContextProvider>
            </ApolloHooksProvider>
          </ApolloProvider>
        </ReduxProvider>
      </ErrorBoundary>
    )
  }
}

export default Root
